module.exports = __webpack_public_path__ + "img/history.f02af644.svg";